import { useTranslation } from 'react-i18next';

import NotFoundImage from '@/shared/assets/not-found.svg';
import { Button } from '@/shared/ui/lib/Button';
import { Logo } from '@/shared/ui/Logo';
import { CustomTypography } from '@/shared/ui/Typography';

import { StyledBox, StyledOops, StyledText, StyledWrapper } from './styles';

export const ErrorFallbackPage = ({
  resetError,
}: {
  resetError?: () => void;
}) => {
  const { t } = useTranslation();

  const handleRefresh = () => {
    if (resetError) {
      resetError();
    }
    window.location.reload();
  };

  return (
    <StyledWrapper>
      <Logo variant="secondary" sx={{ padding: '30px' }} />
      <StyledBox>
        <StyledText>
          <StyledOops>{t('common:errorPage.oops')}</StyledOops>
          <CustomTypography sx={{ fontSize: '24px' }}>
            {t('common:errorPage.somethingWentWrong')}
          </CustomTypography>

          <div>
            <Button
              color="primary"
              variant="contained"
              size="medium"
              onClick={handleRefresh}
            >
              {t('common:errorPage.refresh')}
            </Button>
          </div>
        </StyledText>

        <NotFoundImage />
      </StyledBox>
    </StyledWrapper>
  );
};
